<template>
<div>
  <!-- todo: perhaps display a message for a few seconds, like e.g. 'you will be redirected to a secure microsoft login page...' -->
</div>

</template>

<script>
import { user } from './../../user.js';

export default {
  name: 'Login',
  mounted() {
    // if (!user.isAuthenticated) {
    //   user.signIn();
    // }

    user.msalInstance.handleRedirectPromise()
    .then(response => {
      if (response !== null) {
        user.handleResponse(response, user);
      } else if (!user.isAuthenticated) {
        // Only call signIn if not already authenticated
        console.log("Sign in triggered from mounted hook");
        user.signIn();
      }
    })
    .catch(error => {
      console.error('Error handling redirect response:', error);
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
